export const EmptyState = ({
  title = "Inicie sua busca!",
  description = "Digite um endereço, espaço ou referência e clique em 'Buscar' para iniciar.",
}: {
  title?: string;
  description?: string;
}) => {
  return (
    <div className="flex flex-1 items-center justify-center flex-col p-5">
      <h2 className="text-3xl font-semibold">{title}</h2>
      <p className="text-md text-muted-foreground">{description}</p>
    </div>
  );
};
